import { Component } from "@angular/core";

@Component({
  selector: "oms-bottom-trademark",
  templateUrl: "oms-bottom-trademark.component.html"
})
export class OmsBottomTrademarkComponent {
}
